import api from '../../api';

const fetchFlarumLogin = () => api.get('/flarum_sso/flarum/login');

export {
    fetchFlarumLogin,
};